<template lang="html">

  <section class="ficha -observaciones">

    <h2 class="ficha-title" :style="styles.colorBasic">
      Observaciones
      <a class="" style="min-width: 90px; display: inline-block; padding: 0 30px; float: right;" @click="exportExcel" v-if="!!brand.observacionesManuales && observacionesManuales.length > 0">
        <excel></excel>
      </a>
    </h2>
    
    <template v-for="(observacion, key) in observaciones" v-if="observaciones.length > 0">
      <observacion-el :data="observacion"></observacion-el>
    </template>
    
    <template v-for="(observacion, key) in observacionesManuales" v-if="!!brand.observacionesManuales && observacionesManuales.length > 0">
      <observacion-manual-el :data="observacion" @observacionAnnadida="$emit('observacionAnnadida')"></observacion-manual-el>
    </template>

    <template v-if="observaciones.length == 0 && (!brand.observacionesManuales || observacionesManuales.length == 0)">
      <p>Esta práctica no contiene observaciones</p>
    </template>

    <template v-if="!!brand.observacionesManuales">
      <div class="contenedor-botones row-center" :style="styles.backgroundWhite" style="width: 100%; padding: 25px;">
        <a class="btn -xs" :style="styles.solidPrimary" @click="showPopupObservacionManual = true">Añadir observación / Seguimiento</a>
      </div>
    </template>

    <popup-observacion-manual v-if="showPopupObservacionManual" @cerrar="showPopupObservacionManual = false" 
                              @observacionAnnadida="$emit('observacionAnnadida')"></popup-observacion-manual>     

  </section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import observacion from '@/components/parts/observacion-el';
  import observacionManual from '@/components/parts/observacion-manual-el';

  import popupObservacionManual from '@/components/parts/popup-observacion-manual';
  
  import excel from '@/components/parts/icons/excel';
  import XLSX from 'xlsx';

  export default  {
    name: 'ficha-observaciones',
    props : ['observaciones', 'observacionesManuales'],
    data(){
      return{
        
        documentacion : [],
        showPopupObservacionManual: false,
      }
    },
    mounted(){

    },
    computed :{
      ...mapGetters({
        styles : 'getStyles',
        documentos :'getDocumentos',
        brand : 'getBrand',        
      })
    },
    methods : {
    	...mapActions(['dameContestacionEncuesta']),
      exportExcel() {
        
        let idPractica = this.$route.params.id;

        if (!!!idPractica & Number(this.$route.params.status) > 0) {
          idPractica = this.$route.params.status;
        }

        let data = XLSX.utils.json_to_sheet(this.observacionesManuales);
        const workbook = XLSX.utils.book_new();
        const date = new Date();
        const filename = String(`Observaciones - Práctica ${idPractica}`);
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      },
    },
    components : {
      'observacion-el' : observacion,
      'observacion-manual-el' : observacionManual,
      'popup-observacion-manual': popupObservacionManual,
      'excel': excel
    }
  }
</script>

<style scoped lang="scss">
  .ficha.-observaciones {
    .ficha-title{
      margin-top: 5px;

      &.-documentacion-practica{
        margin-top: 20px;
      }
    }

    p{
      text-align: left;
      width: 100%;
      display: inline-block;
      font-size: 14px;
    }

    .add-documentacion{
      cursor: pointer;
      margin-top: 10px;
    }
  }
  


</style>



// WEBPACK FOOTER //
// src/components/views/ficha-observaciones.vue